import InputFormCheckbox from './InputFormCheckbox';
import InputFormSelect from './InputFormSelect';
import InputFormTextField from './InputFormTextField';

// React Hook Form x Material UI
// https://codesandbox.io/s/react-hook-form-controller-079xx?file=/src/index.js

export default {
  Select: InputFormSelect,
  Checkbox: InputFormCheckbox,
  TextField: InputFormTextField,
};
